import {rolesTypes, statusTypes} from '@/core/constants'

export default {
    defaultObject: {
        role: rolesTypes.OPERATOR,
        status: statusTypes.ACTIVATED
    }
}
